import type { RouteObject } from 'react-router';
import { paths } from '@shared/config/paths';
import { SettingsPage } from './pages/SettingsPage';

export const settingsRoutes: RouteObject[] = [{ path: paths.settings, element: <SettingsPage /> }];
